import { useSearchParams } from "react-router-dom";
import ReferralProgramContentDrawer from "./ReferralProgramContentDrawer";

/**
 * Full-page partner program content manager (offers, terms, FAQ).
 * Opens from Referral list via “Show full page”.
 */
const ReferralProgramContentPage = () => {
  const [params] = useSearchParams();
  const tab = params.get("tab") || "offers";
  const allowed = ["offers", "terms", "faq"];
  const initialTab = allowed.includes(tab) ? tab : "offers";

  return <ReferralProgramContentDrawer open variant="page" initialTab={initialTab} />;
};

export default ReferralProgramContentPage;
